<template>
  <div class="wrap">
    <Light v-if="theme === 'light'" />
    <Dark v-if="theme === 'dark'" />
  </div>
</template>

<script>
import Light from './Light'
import Dark from './Dark'
export default {
  components: {
    Light,
    Dark
  },
  computed: {
    theme() {
      return this.$store.state.theme
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
}
</style>
